export default __webpack_public_path__ + "static/media/logo-atlassian.7db5f0dd.svg";